export default "__VITE_ASSET__e7b69caf__"